import { c as _c } from "react/compiler-runtime";
import { CardContentBadge, classNames, FlexCenter, TextLabel, UnstyledButton } from "@opensea/ui-kit";
import { Add, Remove } from "@opensea/ui-kit/icons";
function UpdateQuantityButton(t0) {
  const $ = _c(12);
  const {
    icon,
    disabled: t1,
    onClick
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const Comp = icon;
  const t2 = disabled && "cursor-not-allowed bg-transparent";
  let t3;
  if ($[0] !== t2) {
    t3 = classNames("flex size-4 items-center justify-center rounded-full bg-blue-2", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onClick) {
    t4 = e => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    };
    $[2] = onClick;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = disabled ? "text-secondary" : "white";
  let t6;
  if ($[4] !== Comp || $[5] !== t5) {
    t6 = <Comp fill={t5} size={16} />;
    $[4] = Comp;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== disabled || $[8] !== t3 || $[9] !== t4 || $[10] !== t6) {
    t7 = <UnstyledButton className={t3} disabled={disabled} onClick={t4}>{t6}</UnstyledButton>;
    $[7] = disabled;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export function SelectItemWithQuantityBadge(t0) {
  const $ = _c(13);
  const {
    max,
    selectedQuantity,
    updateQuantity
  } = t0;
  let t1;
  if ($[0] !== max || $[1] !== selectedQuantity || $[2] !== updateQuantity) {
    t1 = () => {
      if (selectedQuantity < (max ?? Number.POSITIVE_INFINITY)) {
        updateQuantity(selectedQuantity + 1);
      }
    };
    $[0] = max;
    $[1] = selectedQuantity;
    $[2] = updateQuantity;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleAdd = t1;
  let t2;
  if ($[4] !== selectedQuantity || $[5] !== updateQuantity) {
    t2 = () => {
      if (selectedQuantity > 0) {
        updateQuantity(selectedQuantity - 1);
      }
    };
    $[4] = selectedQuantity;
    $[5] = updateQuantity;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleRemove = t2;
  let t3;
  if ($[7] !== handleAdd || $[8] !== handleRemove || $[9] !== max || $[10] !== selectedQuantity || $[11] !== updateQuantity) {
    t3 = <CardContentBadge>{selectedQuantity ? <FlexCenter className="h-8 gap-1 rounded bg-white/80 p-1"><UpdateQuantityButton icon={Remove} onClick={handleRemove} /><TextLabel className="min-w-5 text-center text-black">{selectedQuantity}</TextLabel><UpdateQuantityButton disabled={selectedQuantity === max} icon={Add} onClick={handleAdd} /></FlexCenter> : <button className="-right-2 -top-2 absolute flex size-20 justify-end pt-2 pr-2 focus-visible:outline-hidden" onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        updateQuantity(1);
      }} type="submit"><Add className="fade-in animate-in rounded-full bg-black/80" color="white" size={32} /></button>}</CardContentBadge>;
    $[7] = handleAdd;
    $[8] = handleRemove;
    $[9] = max;
    $[10] = selectedQuantity;
    $[11] = updateQuantity;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}